import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import * as _ from 'lodash';
import { UiService } from '../../../../../services/core.ui.service';
import { ProjectService } from '../../../../../services/project.service';
import { GroupsHelper } from '../../../../../services/core.groups.helper';

@Component({
  selector: 'project-admin-group-add',
  template: require('./project.admin.group.add.html')
})
export class ProjectAdminGroupAddComponent implements OnInit {
  @Input() project: any;
  
  @Output() onAdd = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();

  newGroup: any;
  errors: any;

  constructor(
    private uiService: UiService,
    private projectService: ProjectService,
    private groupsHelper: GroupsHelper
  ) {}

  ngOnInit() {
    this.newGroup = {};
    this.errors = this.groupsHelper.resetErrors();
  }

  formatUnixName(): void {
    this.newGroup.unixName = _.get(this, 'newGroup.unixName', '')
      .toLowerCase()
      .replace(/\s/, '');
    this.errors.unixName.hasError = _.isEmpty(this.newGroup.unixName);
  }

  saveGroup(): void {
    if (!this.groupsHelper.validateGroup(this.newGroup, this.errors)) {
      this.uiService.message.showError('User group validation failed', 'Add Group');
      return;
    }

    this.projectService
      .postGroup(this.project.unixName, {
        unixName: this.project.unixName + '-' + this.newGroup.unixName.toLowerCase(),
        name: this.newGroup.name
      })
      .then(() => {
        this.onAdd.emit();
        this.uiService.message.showSuccess('Group succesfuly added.', 'Add Group');
      })
      .catch((response: any) => {
        if (response.status === 400) {
          this.uiService.message.showError(
            'There was an error adding the group. The Unix Name is already taken.',
            'Add Group'
          );
        } else {
          this.uiService.message.showError(
            'There was an error adding the group. ' + response.data,
            'Add Group'
          );
        }
        this.onClose.emit();
      })
      .finally(() => {});
  }

  doClose(): void {
    this.onClose.emit();
  }
}
